import React, { ChangeEvent, useState } from "react";
import {
  FormControl,
  FormGroup,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useForm } from "react-hook-form";

interface ConsentProps {
  handleCheckboxChange(event: ChangeEvent<any>): void;
  isConsent1: boolean;
  isConsent2: boolean;
  handleCloseModal(): void;
  submit(data:any): Promise<void>;
  disabled: boolean
}

export default function Consent(props: ConsentProps) {
  const {
    handleCheckboxChange,
    isConsent1,
    isConsent2,
    handleCloseModal,
    submit,
    disabled
  } = props;

  const { register, handleSubmit } = useForm({
    mode: "onBlur",
  });

  const handleSubmitForm = () => {
    console.log('in submit')
    handleSubmit(submit);
  }

  const handleInputChange = (event: ChangeEvent<any>) =>
    handleCheckboxChange(event);
  return (
    <Box
      sx={{
        bgcolor: "white",
        width: "80%",
        height: "80%",
        position: "absolute",
        overflowY: "scroll",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        padding: "5%",

      }}
    >
      <Tooltip
        title="Close"
        sx={{
          position: "sticky",
          float: "right",
        }}
      >
        <IconButton onClick={handleCloseModal}>
          <Close />
        </IconButton>
      </Tooltip>
      <form   
  onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(submit)(e);
      }}>
      <Typography
      component={'span'} 
      display={'block'}
        variant="h1"
        sx={{
          marginBottom: 5,
          textAlign: 'center'
        }}
      >
        CONSENT FORM
      </Typography>
      <List>
        <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
          <Typography textAlign="left" component={'span'} >
     I declare that all above statements are true. I
            am aware that knowingly making untrue statements will result in a
            rejection. Positive decisions made on false information will be
            overturned and I will return the full amount paid to me by the
            Claims Conference.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
          <Typography textAlign="left" component={'span'} >
             In the event that I am obligated, pursuant to
            this declaration or otherwise, to return payment to the Claims
            Conference, I hereby agree that I shall also be liable to reimburse
            the Claims Conference for any costs and expenses incurred by the
            Claims Conference in obtaining the return of such payments.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
          <Typography  component={'span'} >
         I am aware that I have no legal entitlement to
            receive this assistance. Without derogating from the above, I
            irrevocably waive - insofar as this is legally admissible - any
            claim that I have or may later assert against the Claims Conference
            relating to or connected with this application or the processing
            thereof.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
          <Typography  component={'span'} >
           I understand and agree that only the Jewish Nazi
            Victim him or herself is eligible for payment; the payments are not
            transferrable or inheritable. I hereby unconditionally agree that
            New York State, USA is the court of exclusive jurisdiction for this
            program.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
          <Typography  component={'span'} >
            Consent for the Use of Personal Data:
            <List>
            <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography  component={'span'} >
                  In order for the Claims Conference to be
                  able to assess your eligibility for assistance under this
                  program, we have asked you to provide detailed personal
                  information about yourself, your family, and your Nazi
                  persecution (we refer to this as 'Personal Data'). This
                  information is necessary to determine your eligibility for
                  assistance in accordance with the grant guidelines of the
                  Claims Conference.
                </Typography>
              </ListItem>
              <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography component={'span'} >
                  <strong> How do we use your Personal Data?</strong><br/>
                </Typography>
                <Typography component={'span'} >
                  The Claims Conference uses the Personal Data you provide to
                  administer and manage this program. The Claims Conference will
                  assess whether you qualify for assistance under grants and
                  benefits programs of the Claims Conference. The Claims
                  Conference will also keep records about the services and
                  benefits which they provide to you through this program. The
                  Claims Conference has a legal obligation under the data
                  protection laws to keep your Personal Data safe and secure.
                  The Claims Conference will process your Personal Data in
                  accordance with their privacy notice which can be found on the
                  Claims Conference's website. For the Claims Conference privacy
                  notice, please visit{" "}
                  <a
                    href="http://www.claimscon.org/about/privacy-policy"
                    target="_blank"
                  >
                    http://www.claimscon.org/about/privacy-policy
                  </a>
                </Typography>
              </ListItem>
              <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography component={'span'} >
                  <strong> Sharing Personal Data with others</strong><br/>
                </Typography>
                <Typography  component={'span'} >
                  It is a pre-condition of the funding that both the funders and
                  the Claims Conference are able to independently monitor and
                  review your eligibility under the programs. Upon request from
                  the funders, the Claims Conference will provide copies of your
                  Personal Data, and any updates, to the funders.
                </Typography>
              </ListItem>
              <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography  component={'span'} >
                  <strong> International transfer of Personal Data</strong><br/>
                </Typography>
                <Typography  component={'span'} >
                  The Claims Conference is located in the USA, Israel and
                  Europe. In processing your application and monitoring any
                  grant of funding, your Personal Data may be transferred to
                  countries outside the European Economic Area ('EEA'), such as
                  the USA and Israel. Those countries may have data protection
                  rules that are different from those of your country. However,
                  the Claims Conference will ensure any such transfers comply
                  with applicable data protection laws as set out in their
                  privacy notice. By ticking the box below we ask for your
                  consent to your Personal Data being transferred in this way as
                  set out below.
                </Typography>
              </ListItem>
              <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography component={'span'} >
                  <strong> External Verification</strong><br/>
                </Typography>
                <Typography component={'span'} >
                  External Verification In order to verify your eligibility for
                  this program, the Claims Conference (and its authorized
                  representatives) may need to check your Personal Data against
                  relevant files relating to your persecution history held by
                  governmental agencies, courts, archives and institutions in
                  Germany, Israel, or elsewhere. In order to conduct such
                  verification and to process your application the Claims
                  Conference may need to process information about your mental
                  and physical health, racial or ethnic origin, religious
                  beliefs, or other special category personal data as defined
                  under European data protection laws (“Sensitive Personal
                  Data”).
                </Typography>
              </ListItem>
              <ListItem sx={{ display: "list-item",  textAlign: "justify",}}>
                <Typography  component={'span'} >
                  <strong> Consent</strong><br/>
                </Typography>
                <Typography  component={'span'} >
                  We require your express consent under European data protection
                  law to process this information. If you consent, please place
                  a checkmark in each box below.
                </Typography>
              </ListItem> 
              <ListItem>
                <FormControl   sx={{textAlign: "justify"}}>
                  <FormGroup onChange={handleInputChange}>
                    <FormControlLabel
                      sx={{
                        fontWeight: "bold",
                        textAlign: 'left',
                        alignContent: 'left',
                        "& .MuiTypography-root": {
                          textAlign: "left"
                        }
                      }}
                      
                      control={<Checkbox />}
                      name="isConsent1"
                      label={
                        <strong style={{textAlign: 'justify'}}>
                          I expressly consent to the Claims Conference
                          processing Sensitive Personal Data in connection with
                          administering this program.
                        </strong>
                      }
                      checked={isConsent1}
                    />
                    <FormControlLabel
                  
                              sx={{
                                fontWeight: "bold",
                                textAlign: 'left',
                                alignContent: 'left',
                                "& .MuiTypography-root": {
                                  textAlign: "left"
                                }
                              }}
                      control={<Checkbox />}
                      name="isConsent2"
                      label={
                        <strong style={{textAlign: 'justify'}}>
                          I expressly consent to the Claims Conference
                          transferring my Personal Data outside of the EEA.
                        </strong>
                      }
                      checked={isConsent2}
                    />
                  </FormGroup>
                </FormControl>
                </ListItem>
                <ListItem sx={{ display: "list-item",  textAlign: "justify"}}>
                <Typography component={'span'}>
                  The Claims Conference recognizes my rights in relation to
                  Personal Data as set out in its privacy notice available on
                  the Claims Conference website. I understand that I may
                  withdraw my consent at any time. To withdraw my consent or
                  exercise any rights under the privacy notice or make
                  complaints, I understand I should contact
                  privacy@claimscon.org, or PO Box 1215, New York, New York
                  10113. However, failure to provide both consents, or the later
                  withdrawal of consent, may adversely affect grant funding and
                  my ability to receive assistance paid for by such funding.
                </Typography>
              </ListItem>
            </List>
          </Typography>
        </ListItem>

   
          <Button
            variant="contained"
            type={"submit"}
            fullWidth
            disabled={!isConsent1 || !isConsent2 || disabled}
         
          >
            PROCEED TO SIGNING
          </Button>
   
        
      </List>
      </form>
    </Box>
  );
}
